import { fetchPhpEigth } from "api";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import SimpleContainer from "components/InputsMex/containers/SimpleContainer";
import { TextInput } from "components/InputsMex/inputs";
import Page from "components/Page";
import {
  ambienteAplicacion,
  urlActualizarCotitzacionAP,
  urlCatalogosCotizador,
} from "constants/urls";
import { useNavbarContext } from "contexts/NavbarContext";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { PASOS_BREADCRUMBS, PRODUCTOS } from "utils/constants";
import { objectIncludesLower } from "utils/object";
import Loading from "wrappers/Loading";
import { DropDownFilter } from "../componentes/entradas";
import { Hogar } from "../constantes/general";

export const InfoGeneralFlexible = ({
  history,
  params: { idCotizacion },
  dataUsuario,
  addToast,
  addWarningToast,
}) => {
  useNavbarContext(Hogar.codProducto);
  const { cliCodigoCore, userIsLoggedIn } = dataUsuario;
  const [loading, setLoading] = useState(true);
  const [bloquear, setBloquear] = useState(false);
  const methods = useForm({
    mode: "onChange",
  });

  const [camposObj, setCamposObj] = useState({});

  const { handleSubmit, errors, reset } = methods;
  const onSubmit = async (data) => {
    setLoading(true);
    reset({ ...data });
    const Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: Hogar.codProducto,
      prodCodigoCore: "hogarCotizadorFlex",
      proTipoPlan: Hogar.proTipoPlan,
      pasoCodigo: "guardarInformacion",
      items: {
        cotPasoCodigo: { descripcion: "informacionRequerida" }, //informacionRequerida
        cotCodigo: idCotizacion || "",
        informacionRequerida: data,
        usuCotiza: { usuCodigo: cliCodigoCore || "" },
      },
    };

    console.log("Enviado", Data);

    const res = await fetchPhpEigth(urlActualizarCotitzacionAP, Data);

    console.log(res);

    if (res?.transaccion === true && res?.id) {
      if (userIsLoggedIn) {
        history.push(`${Hogar.urls.individualFlexible2}/${res?.id}`);
      } else {
        history.push(`/`);
      }
    } else {
      try {
        res.errorDescripcion.forEach((msg) =>
          addWarningToast(msg, { autoDismiss: false })
        );
      } catch (e) {
        addWarningToast("Error desconocido", { autoDismiss: false });
      }
    }
    setLoading(false);
  };
  const onSubmitError = (value) => {
    const arr = Object.keys(value);
    console.log(value[arr[0] || ""].ref);
    value[arr[0] || ""].ref.focus();
  };

  const verificarOpcion = (value) => {
    if (value?.blocked) {
      addToast(value.msgBlock, {
        appearance: "warning",
      });
      return false;
    }
    Object.keys(errors).length === 0 && setBloquear(false);
    return true;
  };

  useEffect(() => {
    const getData = async () => {
      const Data = {
        ambiente: ambienteAplicacion,
        prodCodigo: Hogar.codProducto,
        prodCodigoCore: Hogar.prodCodigoCore,
        pasoCodigo: "informacionCliente",
        datosCotizador: {
          idCotizacion: idCotizacion || "",
          prodCodigo: Hogar.codProducto,
          cotPasoCodigo: { descripcion: "informacionRequerida" }, //informacionRequerida
          usuCotiza: {
            usuCodigo: cliCodigoCore || "",
          },
        },
      };

      const res = await fetchPhpEigth(urlCatalogosCotizador, Data);
      if (res?.catalogo?.formulario) {
        const mappedInputs = res?.catalogo?.formulario?.map((input) => {
          input.rules = {};
          if (input.required) {
            input.rules.required = "Este campo es obligatorio";
          }
          if (input.type === "select") {
            input.rules.validate = {
              opcionNoValida: verificarOpcion,
            };
          }
          return input;
        });
        const inputsObj = Object.fromEntries(
          mappedInputs.map((input) => [input.name, input])
        );
        setCamposObj(inputsObj);
      }
      setLoading(false);
    };

    if (userIsLoggedIn) {
      getData();
    } else {
      history.push("/");
    }
  }, [userIsLoggedIn, history, cliCodigoCore, idCotizacion]);

  const handleRegresar = () => {
    history.push(`${Hogar.urls.datosPersonales}/${idCotizacion}`);
  };

  return (
    <Loading loading={loading}>
      <div className='cr-content'>
        <Page>
          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[PRODUCTOS.HOGAR].breadCrumbPasosCotizacionHogarFlex[2]}
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.HOGAR]?.pasosHogarFlex}
          />

          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit, onSubmitError)}>
              <div className='row justify-content-center mx-2'>
                <div className='col-12 text-center mt-3'>
                  <h2>Información requerida</h2>
                </div>
                <div className='col-11 col-md-10 d-flex flex-wrap justify-content-between border p-5'>
                  {camposObj?.tipoVivienda && <Select {...camposObj?.tipoVivienda} />}

                  {camposObj?.adimentosEspeciales && (
                    <Select {...camposObj?.adimentosEspeciales} />
                  )}

                  {camposObj?.tipoUso && <Select {...camposObj?.tipoUso} />}

                  {camposObj?.tiempoUsoBien && <Select {...camposObj?.tiempoUsoBien} />}

                  {camposObj?.aniosConstruccion && (
                    <Select {...camposObj?.aniosConstruccion} />
                  )}

                  {camposObj?.rentadaPlataformaDigital && (
                    <Select {...camposObj?.rentadaPlataformaDigital} />
                  )}

                  {camposObj?.cercaniaRioPresa && (
                    <Select {...camposObj?.cercaniaRioPresa} />
                  )}

                  {camposObj?.cercaniaMar && <Select {...camposObj?.cercaniaMar} />}

                  {camposObj?.colineanteSinFincar && (
                    <Select {...camposObj?.colineanteSinFincar} />
                  )}

                  {camposObj?.tipoConstruccion && (
                    <Select {...camposObj?.tipoConstruccion} />
                  )}
                  {camposObj?.seguroAig && <Select {...camposObj?.seguroAig} />}

                  {camposObj?.numeroPoliza &&
                    objectIncludesLower(methods.watch("seguroAig"), "si") && (
                      <InputText {...camposObj?.numeroPoliza} />
                    )}
                </div>
              </div>
              <div className='row justify-content-center my-5'>
                <div className='col-11 col-sm-5 col-md-3 col-xl-2'>
                  <button
                    className='btn btn-atras-api'
                    onClick={handleRegresar}
                    type='button'>
                    Atrás
                  </button>
                </div>
                <div className='col-11 col-sm-5  col-md-3 col-xl-2'>
                  <button
                    disabled={bloquear}
                    className='btn btn-siguiente-api'
                    type='submit'>
                    Continuar
                  </button>
                </div>
              </div>
            </form>
          </FormProvider>
        </Page>
      </div>
    </Loading>
  );
};

const FieldWrapper = ({ input, children }) => (
  <div key={input.name} className='col-md-5 mt-3'>
    <div className='form-group w-100'>
      <SimpleContainer label={input.label} name={input.name}>
        {children}
      </SimpleContainer>
    </div>
  </div>
);
const InputText = (input) => (
  <FieldWrapper input={input}>
    <TextInput
      inputProps={{
        name: input.name,
        type: input.type,
      }}
      defaultValue={input?.value}
      rules={input.rules}
      extrasClasses='hide-arrows'
      numerico={input?.type === "number"}
    />
  </FieldWrapper>
);

const verificarPreSeleccion = (input) => {
  if (input.valuePreselected && !input?.value) {
    const valuePreselected = input?.options.find(preselected => 
      preselected.value.value === input.valuePreselected
    );
      return valuePreselected?.value ?? input?.value;
  }
  return input.value;
}

const Select = (input) => (
  <FieldWrapper input={input}>
    <DropDownFilter
      name={input.name}
      options={input.options}
      helpText={"Seleccionar"}
      defaultValue={
      verificarPreSeleccion(input)
}
      rules={input.rules}
    />
  </FieldWrapper>
);
